"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

const material_1 = require("@mui/material");

const react_1 = __importDefault(require("react"));

const SskyTableCell_1 = __importDefault(require("../SskyTableCell/SskyTableCell"));

const SskyTooltip_1 = __importDefault(require("../SskyTooltip/SskyTooltip"));

const SskyEnhancedTableHead = props => {
  var _a;

  const createSortHandler = property => event => {
    props.onRequestSort(event, property);
  };

  const renderCellContent = (column, order, orderBy) => {
    if (column.sortable) {
      return react_1.default.createElement(SskyTooltip_1.default, {
        title: "Sort",
        placement: column.numeric ? "bottom-end" : "bottom-start",
        enterDelay: 300
      }, react_1.default.createElement(material_1.TableSortLabel, {
        active: orderBy === column.id,
        direction: order,
        onClick: createSortHandler(column.id)
      }, column.value));
    }

    return column.value;
  };

  const getCells = () => {
    return props.columnData.map(column => {
      return react_1.default.createElement(SskyTableCell_1.default, {
        key: column.id,
        numeric: column.numeric,
        padding: column.disablePadding ? 0 : "default",
        sortDirection: props.orderBy === column.id ? props.order : false,
        className: column.className
      }, renderCellContent(column, props.order, props.orderBy));
    });
  };

  return react_1.default.createElement(material_1.TableHead, {
    className: `tableHeader ${props.className}`
  }, react_1.default.createElement(material_1.TableRow, null, props.renderSelectionCell && react_1.default.createElement(material_1.TableCell, {
    padding: "checkbox",
    style: props.selectionCellHeader ? {
      paddingLeft: "1.2em"
    } : {}
  }, (_a = props.selectionCellHeader) !== null && _a !== void 0 ? _a : "", !props.selectionCellHeader && props.multiSelection && react_1.default.createElement(material_1.Checkbox, {
    color: "primary",
    indeterminate: props.numSelected > 0 && props.numSelected < props.rowCount,
    checked: props.numSelected > 0 && props.numSelected === props.rowCount,
    onChange: props.onSelectAllClick,
    "data-testid": "testId-table-head-checkbox",
    disabled: props.disableSelection
  })), getCells()));
};

SskyEnhancedTableHead.defaultProps = {
  multiSelection: true
};
exports.default = react_1.default.memo(SskyEnhancedTableHead);